export const getCouponBannerStyles = () => ({
  container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: 69,
    marginBottom: 48,
  },
  'container-l': {
    height: 50,
  },
  'container-m': {
    height: 50,
  },
  'container-s': {
    height: 50,
    marginBottom: 16,
  },
  couponOverlayBase: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    border: '1.5px solid #D4EC8E',
    borderRadius: '48px',
  },
  couponOverlayBackground: {
    background: 'linear-gradient(0deg, #FFFFFF, #FFFFFF)',
  },
  couponOverlayContent: {
    background: 'linear-gradient(90deg, rgba(212, 236, 142, 0.25) 0%, rgba(172, 216, 193, 0.25) 100%)',
  },
  coinImageContainer: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 125,
    height: 69,
    '& img': {
      height: 69,
      aspectRatio: 1.81,
    },
  },
  'coinImageContainer-l': {
    '& img': {
      height: 50,
    },
  },
  'coinImageContainer-m': {
    '& img': {
      height: 50,
    },
  },
  'coinImageContainer-s': {
    '& img': {
      height: 50,
    },
  },
  couponText: {
    marginRight: '20px',
    color: '#031A02',
    fontSize: '20px',
    lineHeight: '28px',
    fontWeight: 'bold',
  },
  'couponText-l': {
    fontSize: '14px',
    lineHeight: '18px',
  },
  'couponText-m': {
    fontSize: '12px',
    lineHeight: '16px',
  },
  'couponText-s': {
    fontSize: '12px',
    lineHeight: '16px',
  },
  couponDetails: {
    textDecoration: 'underline',
  },
  couponDetailsContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
  },
  claimCouponBtn: {
    alignSelf: 'center',
    marginTop: '4px !important',
  },
});
